import { User } from "./User";
import { Company } from "./Company";
import { Image } from "./Image";
import { Profile } from "./Profile";
import { Project } from "./Project";
import { Post, PostCategory, PostState } from "./Post";
import { PostSpace } from "./PostSpace";
import { CompanyPostPin } from "./CompanyPostPin";
import { PortfolioProject } from "./PortfolioProject";
import { CompanyValue } from "./CompanyValue";
import { CompanyValueFeature } from "./CompanyValueFeature";
import { CompanyMembership } from "./CompanyMembership";
import { CompanyMembershipSection } from "./CompanyMembershipSection";
import { CompanyFollowing } from "./CompanyFollowing";

// Export interfaces
export {
  User,
  Company,
  Image,
  Profile,
  Project,
  Post,
  PostCategory,
  PostState,
  PostSpace,
  CompanyPostPin,
  PortfolioProject,
  CompanyValue,
  CompanyValueFeature,
  CompanyMembership,
  CompanyMembershipSection,
  CompanyFollowing,
};

export interface EntityHash {
  users: Entity<User>;
  companies: Entity<Company>;
  images: Entity<Image>;
  profiles: Entity<Profile>;
  projects: Entity<Project>;
  posts: Entity<Post>;
  post_spaces: Entity<PostSpace>;
  company_post_pins: Entity<CompanyPostPin>;
  portfolio_projects: Entity<PortfolioProject>;
  company_values: Entity<CompanyValue>;
  company_value_features: Entity<CompanyValueFeature>;
  company_memberships: Entity<CompanyMembership>;
  company_membership_sections: Entity<CompanyMembershipSection>;
}

export const initialEntitiesMap: EntitiesMap = {
  users: {},
  companies: {},
  images: {},
  profiles: {},
  projects: {},
  posts: {},
  post_spaces: {},
  company_post_pins: {},
  portfolio_projects: {},
  company_values: {},
  company_value_features: {},
  company_memberships: {},
  company_membership_sections: {},
};

export type EntityKey = keyof EntityHash;
export type EntityType = EntityHash[EntityKey];

export interface EntityMap<T extends EntityType> {
  [key: string]: T | undefined;
}
export type EntitiesMap = { [key in EntityKey]?: EntityMap<EntityHash[key]> };

export type VerifiedEntity<T extends EntityType, V extends keyof T> = { [K in V]: T[K] } &
  { readonly [K in keyof Omit<T, V>]?: T[K] };



// WEBPACK FOOTER //
// ./frontend/src/entities/index.ts